import {Stack, Typography, useTheme} from '@mui/material';
import React from 'react';
import {DataInfoBilletProps} from './types';

const DataInfoBillet = ({
	title,
	subtitle,
	customSubtitleFontSize = '1rem',
	customSubtitleFontWeight = 400,
}: DataInfoBilletProps) => {
	const {colors} = useTheme();
	return (
		<Stack>
			<Typography
				fontSize={'0.875rem'}
				fontWeight={subtitle ? 400 : 600}
				color={colors.light.text.secondary}>
				{title}
			</Typography>
			{subtitle ? (
				<Typography fontSize={customSubtitleFontSize} fontWeight={customSubtitleFontWeight}>
					{subtitle}
				</Typography>
			) : null}
		</Stack>
	);
};

export {DataInfoBillet};
